import {AllScoresLinkParams} from "./all-scores-container-link-params";
import {BaseMatchModel} from "../../../core/components/router/models/base-match-model";

export class AllScoresMatchModel extends BaseMatchModel {
  params: AllScoresLinkParams;
}
